
        <div class="space-y-6 text-[color:var(--foreground)]">
            <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <div>
                    <a [routerLink]="backLink" queryParamsHandling="preserve" class="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white">
                        <lucide-icon name="arrow-left" class="h-4 w-4"></lucide-icon>
                        {{ backLabel }}
                    </a>
                    <h1 class="text-3xl font-bold mt-2">Edit Property</h1>
                    <p class="text-white/70">Update key details and images</p>
                </div>
                <div class="flex gap-2">
                    <button *ngIf="propertyId && canDuplicateProperty" type="button" (click)="duplicateProperty()" [disabled]="saving || duplicating" class="inline-flex items-center gap-2 rounded-lg border border-white/20 px-4 py-2 text-white transition hover:bg-white/10 disabled:opacity-60">
                        <lucide-icon name="copy" class="h-4 w-4"></lucide-icon>
                        Duplicate
                    </button>
                    <a *ngIf="propertyId" [routerLink]="viewLink" queryParamsHandling="preserve" class="inline-flex items-center gap-2 rounded-lg border border-white/20 px-4 py-2 text-white transition hover:bg-white/10">
                        <lucide-icon name="eye" class="h-4 w-4"></lucide-icon>
                        View
                    </a>
                </div>
            </div>

            <ng-container *ngIf="!loading && property; else loadingTpl">
                <div class="space-y-6">
                    <app-developer-property-edit-stepper [vm]="view"></app-developer-property-edit-stepper>

                    <app-developer-property-edit-form [vm]="view"></app-developer-property-edit-form>

                </div>
            </ng-container>

            <ng-template #loadingTpl>
                <!-- Skeleton mirrors the loaded content: header row + stepper pills + form card -->
                <div class="space-y-6 animate-pulse" aria-busy="true" aria-live="polite">
                    <!-- header: back link + title + subtitle + 2 action buttons -->
                    <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                        <div class="space-y-2">
                            <div class="h-4 w-24 rounded bg-white/10"></div>
                            <div class="h-8 w-40 rounded bg-white/10"></div>
                            <div class="h-4 w-56 rounded bg-white/10"></div>
                        </div>
                        <div class="flex gap-2">
                            <div class="h-9 w-28 rounded-lg border border-white/20 bg-white/5"></div>
                            <div class="h-9 w-20 rounded-lg border border-white/20 bg-white/5"></div>
                        </div>
                    </div>

                    <!-- stepper: 5 numbered pill buttons (Basics / Areas / Layout / Pricing / Fees) -->
                    <div class="flex flex-wrap items-center gap-3 pb-2">
                        <div *ngFor="let i of [1,2,3,4,5]" class="flex items-center gap-2 rounded-full border border-white/20 px-3 py-1.5">
                            <div class="h-6 w-6 rounded-full border border-white/30 bg-white/10"></div>
                            <div class="h-3 w-12 rounded bg-white/10"></div>
                        </div>
                    </div>

                    <!-- form card: 2-col field grid + description + offer-assets sub-card -->
                    <div class="space-y-4 rounded-2xl border border-white/20 bg-white/5 p-5 shadow-xl min-w-0">
                        <div class="grid gap-3 md:grid-cols-2">
                            <div class="space-y-2" *ngFor="let i of [1,2]">
                                <div class="h-4 w-16 rounded bg-white/10"></div>
                                <div class="h-10 w-full rounded-lg border border-white/20 bg-white/10"></div>
                            </div>
                        </div>
                        <div class="space-y-2">
                            <div class="h-4 w-24 rounded bg-white/10"></div>
                            <div class="h-24 w-full rounded-lg border border-white/20 bg-white/10"></div>
                        </div>
                        <div class="rounded-xl border border-white/15 bg-white/5 p-4 space-y-4">
                            <div class="space-y-1">
                                <div class="h-4 w-28 rounded bg-white/10"></div>
                                <div class="h-3 w-44 rounded bg-white/10"></div>
                            </div>
                            <div class="grid gap-4 md:grid-cols-2">
                                <div class="rounded-xl border border-white/15 bg-white/5 p-4 space-y-3" *ngFor="let i of [1,2]">
                                    <div class="h-3 w-24 rounded bg-white/10"></div>
                                    <div class="h-20 w-full rounded-lg bg-white/10"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>

	        <div *ngIf="showImageModal && modalImageUrl" class="property-image-modal fixed inset-0 z-[60] flex items-center justify-center overflow-y-auto bg-black/70 p-3 backdrop-blur sm:p-4">
            <div class="relative flex w-full max-w-5xl items-center justify-center px-12 sm:px-16">
                <button type="button" class="absolute left-0 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-3 text-white hover:bg-black/70" (click)="cycleModalImage(-1)">
                    <lucide-icon name="chevron-left" class="h-5 w-5"></lucide-icon>
                </button>
                <div class="relative w-full">
                    <button type="button" (click)="closeImageModal()" class="absolute right-2 top-2 z-10 rounded-full bg-black/50 p-2 text-white hover:bg-black/70">
                        <lucide-icon name="x" class="h-5 w-5"></lucide-icon>
                    </button>
                    <img [src]="modalImageUrl" alt="Property image enlarged" class="max-h-[calc(100dvh-2rem)] w-full rounded-lg border border-white/20 bg-black object-contain sm:max-h-[calc(100dvh-3rem)]" />
                </div>
                <button type="button" class="absolute right-0 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-3 text-white hover:bg-black/70" (click)="cycleModalImage(1)">
                    <lucide-icon name="chevron-right" class="h-5 w-5"></lucide-icon>
                </button>
            </div>
        </div>
	    
